import moment from 'moment-timezone';

export default {
  _getStartTimeValue(item, rowIndex, showStartOn) {
    item = item || this.props.item;
    rowIndex = typeof rowIndex !== 'number' ? this.props.rowIndex : rowIndex;
    showStartOn =
      typeof showStartOn === 'undefined' ? this.props.showStartOn : showStartOn;

    let itemStartOn = item.get('startOnAdjusted');

    if (rowIndex === 0 && !itemStartOn) {
      return showStartOn;
    }

    return itemStartOn || moment().startOf('day').valueOf();
  },
};
